import classNames from 'classnames';
import React from 'react';

import './imageResourceCards.scss';

const cardImageClasses = classNames(
    'eds-media-card-content--fixed',
    'eds-media-card-content__image-content',
);
const cardTitleClasses = classNames(
    'eds-media-card-content__title',
    'eds-text-color--grey-900',
    'eds-text-bl',
    'image-resource-card-title',
);

interface ImageResourceCard {
    title: string;
    bodyText: string;
    linkUrl: string;
    imageUrl: string;
}

const ImageResourceCard = ({
    title,
    bodyText,
    linkUrl,
    imageUrl,
}: ImageResourceCard) => (
    <div className="eds-g-cell eds-g-cell-md-4-12 eds-g-cell-sm-6-12 eds-g-cell-1-1">
        <div className="mktg-layout-align--stack-reverse eds-l-mar-all-2 eds-l-pad-vert-1">
            <a href={linkUrl} target="_blank" rel="noopener noreferrer">
                <div className="image-resource-card-image">
                    <div className="eds-media-card-content__image-wrapper">
                        <div className={cardImageClasses}>
                            <img
                                className={cardImageClasses}
                                src={imageUrl}
                                alt=" Making the Decision to Postpone Your Event"
                            />
                        </div>
                    </div>
                </div>
                <div className="eds-media-card-content__content">
                    <div className="eds-media-card-content__content__principal eds-l-pad-all-2">
                        <div className="eds-media-card-content__primary-content">
                            <div className={cardTitleClasses}>{title}</div>
                        </div>
                        <div className="eds-media-card-content__sub-content">
                            <div className="eds-l-mar-top-2">
                                <p className="eds-text-bs eds-text-color--grey-700">
                                    {bodyText}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </a>
        </div>
    </div>
);

export interface ImageResourceCardsModuleProps {
    imageCards: ImageResourceCard[];
}

const ImageResourceCardsModule = ({
    imageCards,
}: ImageResourceCardsModuleProps) => (
    <section className="marketing-container__max-width eds-l-pad-bot-10 eds-l-pad-top-20">
        <div className="eds-g-group">
            {imageCards.map((card, idx) => (
                <ImageResourceCard key={idx} {...card} />
            ))}
        </div>
    </section>
);

export default ImageResourceCardsModule;
